module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-WHITE.27dca537.svg";